import TransactionsPage from "@/pages/TransactionsPage";

export default function TransactionsOut() {
  return <TransactionsPage type="out" />;
}
